import React from 'react';
import {Skeleton, Stack} from '@mui/material';

import {StyledCard} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages/private/hooks';

export function ProviderAddressSkeleton() {
	const {isMobile} = useMediaQueries();

	return (
		<StyledCard.Container
			sx={{
				borderRadius: isMobile ? 0 : 1,
			}}>
			<Stack justifyContent="space-between" alignItems="center" direction="row" gap={2}>
				<Skeleton
					variant="rectangular"
					sx={{fontSize: '1rem', width: '100%', maxWidth: 200}}
				/>
				<Skeleton variant="rectangular" sx={{fontSize: '1rem'}} width={56} />
			</Stack>
			<Skeleton variant="rectangular" height={48} width="100%" />
			<Stack alignItems={'end'}>
				<Skeleton
					sx={{borderRadius: '21px'}}
					variant="rounded"
					width={isMobile ? '100%' : 187}
					height={42}
				/>
			</Stack>
		</StyledCard.Container>
	);
}
